import { Component, OnInit, Inject, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { LoggingService } from '../shared/services/logging/logging.service';
import { Store, select } from '@ngrx/store';
import { IUserRole } from './IUserRole';
import { Observable } from 'rxjs';
import * as fromUserRole from './store/reducers';
import * as fromUser from '../user-info/store/user.reducer';
import { UserRoleState } from './store/reducers';
import { takeWhile } from 'rxjs/operators';
import { SetUserInfo } from '../user-info/store/user.actions';
import { IUserInfo } from '../user-info/IUserInfo';
import { UserInfoService } from '../user-info/user-info.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'ef-user-role',
    templateUrl: './user-role.component.html',
    styleUrls: ['./user-role.component.scss'],
    standalone: false
})
export class UserRoleComponent implements OnInit, OnDestroy {

  active = true;
  roleFormGroup: UntypedFormGroup;
  public userInfoService: UserInfoService;
  public userRoles$: Observable<Array<IUserRole>>;
  public userRoles: Array<IUserRole>;
  public userInfo$: Observable<IUserInfo>;
  public userInfo: IUserInfo;
  public selectedRoleID: number;
  @Input() public roleGroupName: string;
  constructor(
    private store: Store<UserRoleState>,
    private userInfoStore: Store<fromUser.State>,
    @Inject(LoggingService) private log: LoggingService,
  ) {
    this.roleFormGroup = new UntypedFormGroup({
      userRole: new UntypedFormControl(null)
    });

   }

  ngOnInit() {
    this.userRoles$ = this.store.pipe(select(fromUserRole.getUserRoles));
    this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));

    this.roleFormGroup.controls['userRole'].valueChanges.pipe(
      takeWhile(_ => this.active)
    )
    .subscribe(value => this.roleChosen(value));

    this.userInfo$
    .pipe(
      takeWhile(() => this.active)
    )
    .subscribe(x => this.userInfo = x);

    this.userRoles$
    .pipe(
      takeWhile(() => this.active)
    )
    .subscribe(x => this.userRoles = x);
  }

  ngOnDestroy() {
    this.active = false;
  }
// INFO: these XXXDisplay functions are for deficiences with mat-autocomplete, see
// https://material.angular.io/components/autocomplete/overview#setting-separate-control-and-display-values
  public roleDisplay(id) {
    const that = this as any;
    if (that) {
      // return that.find(a => a.AuthTypeId === id).AuthType;
      return that.findIndex(x => x.RoleGroupID === id) < 0
      ? id
      : that.find(a => a.RoleGroupID === id).GroupName;
    }
  }
  roleChosen(roleID: number) {
    this.log.debug({type: 'UserRoleComponent:roleChosen', roleID});
    this.selectedRoleID = roleID;
    this.userInfoStore.dispatch(new SetUserInfo({...this.userInfo, DefaultRoleGroupID: roleID}));
    this.userRoles.forEach((role) => {
      if (role.RoleGroupID == this.selectedRoleID) {
        this.roleGroupName = role.GroupName;
      }
    });
  }
}
